import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'; // 1. Importar componentes do Reactstrap
import './styles.css';
import { Context } from "../../hooks/useAuthContext";
import api from "../../services/axiosConfig";
import { toast } from "react-toastify";

function ComunicadoAlerta() {
    const { userData, exibirLogs, fetchLoggedUser } = useContext(Context);
    const [modalAberto, setModalAberto] = useState(false);
    const [loading, setLoading] = useState(false);

    const htmlContent = `
        <div style="text-align: justify;">
            <p><b>Comunicado sobre Emissão de Notas Fiscais e Prazos de Pagamento</b></p>
            
            <p>Para manter a organização e o bom funcionamento do nosso fluxo financeiro, a partir de
            agora adotaremos um cronograma fixo de pagamentos, vinculado à emissão das notas
            fiscais.</p>
            
            <b>Pagamentos serão realizados em duas etapas:</b>
            <ul>
                <li>
                    Quem enviar a nota fiscal até às 16h do dia 01 (desde que seja dia útil), receberá no
                    mesmo dia. Caso o dia 01 não seja útil, o pagamento será efetuado no próximo dia
                    útil.
                </li>
                <li>
                    Quem enviar a nota fiscal entre os dias 02 e 10 do mês, receberá o pagamento no
                    dia 11 (ou no próximo dia útil, caso o dia 11 não seja útil).
                </li>
            </ul>
            <b>Importante:</b>
            <p>
                A nota fiscal referente ao valor acordado no mês vigente deve ser emitida até o dia 10 do
                mês. Caso isso não ocorra, será concedido um prazo de tolerância e a emissão deverá
                ocorrer entre o dia 01 e 10 do mês subsequente.
            </p>
            <p>
                Se a nota não for emitida até essa data, o valor correspondente será destinado a doações
                sociais, entendendo-se que a ausência da emissão dentro do prazo caracteriza renúncia ao
                recebimento.
            </p>
            <p>
                Nosso objetivo com essa medida é garantir mais previsibilidade, responsabilidade e
                agilidade no processo de repasse, além de evitar acúmulos e impactos no planejamento
                financeiro de ambas as partes.
            </p>
            <p>
                Agradecemos a compreensão e estamos à disposição para esclarecer quaisquer dúvidas.
            </p>
        </div>
    `;

    async function disagreeMessage() {
        const result = await Swal.fire({
            title: "Aviso",
            text: "Se não aceitar os termos, você não poderá utilizar o sistema!",
            icon: "warning",
            position: "center",
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            setModalAberto(true);
        }
    }

    useEffect(() => {
        setModalAberto(true);
    }, []);

    async function handleAccept() {
        setLoading(true)
        try {
            const payload = {
                acceptedTerm: true,
                listTerms: ["Aceito os termos de uso e a política de privacidade inicias", 
                            "Comunicado sobre Emissão de Notas Fiscais e Prazos de Pagamento"],
            };

            await api.put(
                `/auth/user/update/${userData.uid}`,
                payload
            );
            setModalAberto(false)
            toast.success("Você aceitou os termos.")
        } catch (error) {
            exibirLogs && console.error("Erro desconhecido:", error);
            toast.error("Erro desconhecido");
        } finally {
            setLoading(false);
        }
    }

    function handleDisagree() {
        setModalAberto(false); 
        disagreeMessage();
    }

    return (
        <Modal
            isOpen={modalAberto}
            size="md" 
            centered 
            backdrop="static" 
            keyboard={false} 
            scrollable={true}>
            <ModalHeader>
                Comunicado nas Alterações dos Termos
            </ModalHeader>
            <ModalBody>
                <div style={{ paddingLeft: 20, paddingRight: 20}} dangerouslySetInnerHTML={{ __html: htmlContent }} />
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleAccept}>
                    Aceito
                </Button>
                <Button color="danger" onClick={handleDisagree}>
                    Não aceito!
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default ComunicadoAlerta;